import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getListBlackListsSuccess,
  getListBlackListsFailed,
  GET_LIST_BLACKLIST_START,
} from '../../actions/blackList'
import { api } from '~/services/api'

/**
 * get list blacklist api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListBlackListsApi = (props) => {
  var uri = `/sponsor-tournament-blacklist`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetBlackLists(action) {
  try {
    const response = yield call(getListBlackListsApi, action?.payload)
    yield put(getListBlackListsSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getListBlackListsFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list blacklist
 */
export default function* watchGetBlackLists() {
  yield takeLatest(GET_LIST_BLACKLIST_START, doGetBlackLists)
}
